import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { doc, setDoc, getDoc, getDocs, updateDoc, deleteDoc, collection, query, where, serverTimestamp } from 'firebase/firestore';
import { auth, googleProvider, db } from './firebase';

// ======== LOGIN EMAIL/SENHA ========
export const loginWithEmail = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// ======== CADASTRO EMAIL/SENHA ========
export const registerWithEmail = async (email, password, userData) => {
  const cred = await createUserWithEmailAndPassword(auth, email, password);

  // Verificar se existe convite pendente para este email
  const invite = await findPendingInvite(email);

  if (invite) {
    // Vincular convite ao uid real
    await setDoc(doc(db, 'users', cred.user.uid), {
      uid: cred.user.uid,
      email: email.toLowerCase().trim(),
      displayName: userData.nome || invite.displayName || '',
      role: invite.role,
      masterId: invite.masterId,
      gestorId: invite.gestorId || null,
      teamId: invite.teamId || null,
      telefone: userData.telefone || '',
      empresa: userData.empresa || '',
      status: 'active',
      criadoEm: serverTimestamp(),
      atualizadoEm: serverTimestamp(),
    });
    // Remover doc pendente se for diferente
    if (invite.id !== cred.user.uid) {
      await deleteDoc(doc(db, 'users', invite.id));
    }
  } else {
    // Novo registro sem convite = Master
    await setDoc(doc(db, 'users', cred.user.uid), {
      uid: cred.user.uid,
      email: email.toLowerCase().trim(),
      displayName: userData.nome || '',
      role: 'master',
      masterId: cred.user.uid,
      gestorId: null,
      teamId: null,
      telefone: userData.telefone || '',
      empresa: userData.empresa || '',
      segmento: userData.segmento || '',
      plano: userData.plano || 'simulador',
      status: 'active',
      criadoEm: serverTimestamp(),
      atualizadoEm: serverTimestamp(),
    });
  }

  return cred;
};

// ======== LOGIN GOOGLE ========
export const loginWithGoogle = async () => {
  const cred = await signInWithPopup(auth, googleProvider);
  const userRef = doc(db, 'users', cred.user.uid);
  const snap = await getDoc(userRef);

  if (!snap.exists()) {
    // Verificar convite pendente
    const invite = await findPendingInvite(cred.user.email);

    if (invite) {
      await setDoc(userRef, {
        uid: cred.user.uid,
        email: cred.user.email.toLowerCase().trim(),
        displayName: cred.user.displayName || invite.displayName || '',
        role: invite.role,
        masterId: invite.masterId,
        gestorId: invite.gestorId || null,
        teamId: invite.teamId || null,
        telefone: '',
        empresa: '',
        status: 'active',
        criadoEm: serverTimestamp(),
        atualizadoEm: serverTimestamp(),
      });
      if (invite.id !== cred.user.uid) {
        await deleteDoc(doc(db, 'users', invite.id));
      }
    } else {
      // Novo via Google = Master
      await setDoc(userRef, {
        uid: cred.user.uid,
        email: cred.user.email.toLowerCase().trim(),
        displayName: cred.user.displayName || '',
        role: 'master',
        masterId: cred.user.uid,
        gestorId: null,
        teamId: null,
        telefone: '',
        empresa: '',
        segmento: '',
        plano: 'simulador',
        status: 'active',
        criadoEm: serverTimestamp(),
        atualizadoEm: serverTimestamp(),
      });
    }
  }

  return cred;
};

// ======== BUSCAR CONVITE PENDENTE ========
const findPendingInvite = async (email) => {
  const q = query(
    collection(db, 'users'),
    where('email', '==', email.toLowerCase().trim()),
    where('status', '==', 'pending')
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return { id: snap.docs[0].id, ...snap.docs[0].data() };
};

// ======== VERIFICAR SE EMAIL TEM CONVITE (para UI) ========
export const checkInvite = async (email) => {
  const invite = await findPendingInvite(email);
  return invite || null;
};

// ======== LOGOUT ========
export const logout = () => signOut(auth);

// ======== OBSERVER ========
export const onAuthChange = (callback) => onAuthStateChanged(auth, callback);

// ======== BUSCAR PERFIL ========
export const getUserProfile = async (uid) => {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};